/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { useState, useEffect } from "react";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, getDocs, collection, updateDoc } from "firebase/firestore";
import SoftBadge from "components/SoftBadge";

function AutoDeletePatients() {
  const [selectedTimeFrame, setSelectedTimeFrame] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveError, setSaveError] = useState(false);

  const handleSelectChange = selectedOption => {
    setSelectedTimeFrame(selectedOption ? selectedOption.value : '');
  };

  useEffect(() => {
    const fetchUserConfiguration = async () => {

      setTimeout(async () => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const db = getFirestore();
          const userDocRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(userDocRef);
          if (docSnap.exists()) {
            // Assuming the field storing the time frame is named "autoDeleteTimeFrame"
            const userData = docSnap.data();
            const timeFrame = userData.autoDeleteTimeFrame;
            if (timeFrame) {
              setSelectedTimeFrame(timeFrame);
            }
          console.log("fethed time frame:", timeFrame)
          } else {
            console.log("No such document!");
          }
        }
      }, 1500);
    };

    fetchUserConfiguration();
  }, []);


  const saveConfiguration = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const db = getFirestore();
      const userDocRef = doc(db, "users", user.uid);
      try {
        await updateDoc(userDocRef, {
          autoDeleteTimeFrame: selectedTimeFrame
        });
        setSaveSuccess(true);
        console.log('Time frame saved:', selectedTimeFrame);
        
        setTimeout(() => {
          setSaveSuccess(false);
        }, 5000);
      } catch (error) {
        console.error("Error saving configuration:", error);
        setSaveError(true);

        setTimeout(() => {
          setSaveError(false);
        }, 5000);
      }
    }
  };
  

 return (
  <Card >
    <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={4} px={2}>
      <SoftTypography pl={1} variant="h5">Auto Delete Patient Documentation</SoftTypography>
      <SoftBox>
        {/* Tooltip and Button can be uncommented and used as needed */}
      </SoftBox>
    </SoftBox>
    <SoftBox pt={1} px={2} pl={3}>
      <SoftTypography variant="button" color="text" fontWeight="regular" >
        Set a period after which patient documents are automatically deleted. If no period is specified, documents are auto-deleted 30 days after the patient&apos;s last visit.
      </SoftTypography>
    </SoftBox>
    <SoftBox mb={3} display="flex" alignItems="center" justifyContent="space-between" pt={4} px={2}>
      <SoftBox display="flex" alignItems="center" pr={4}> {/* Adjust padding as needed */}
        <SoftSelect 
          placeholder="30 Days (Default)"
          success={ saveSuccess ? true : false }
          value={selectedTimeFrame ? { value: selectedTimeFrame, label: selectedTimeFrame } : null}
          onChange={handleSelectChange}
          options={[
            { value: "12 Hours", label: "12 Hours"},
            { value: "1 Day", label: "1 Day"},
            { value: "3 Days", label: "3 Days"},
            { value: "7 Days", label: "7 Days"},
            { value: "14 Days", label: "14 Days"},
            { value: "21 Days", label: "21 Days"},
          ]}
          isClearable={true}
          menuPortalTarget={document.body} // Render the dropdown menu as a portal appended to the body
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Adjust z-index as needed
        />
        
      </SoftBox>
      <SoftButton variant="contained" color="dark" size="small" onClick={saveConfiguration} >
        Save Configuration
      </SoftButton>
    </SoftBox>
    { saveSuccess && (
      <SoftBox mt={1} mb={3} display="flex" justifyContent="center" alignItems="center" >
        <SoftBadge
          variant="contained"
          color="success"
          size="xs"
          badgeContent={
              <SoftTypography color="black" variant="button" >
                  Configuration Updated Succesfully 
              </SoftTypography>
          }
          circular
          container
          />
      </SoftBox>
    )}
    { saveError && (
      <SoftBox mt={1} mb={3} display="flex" justifyContent="center" alignItems="center" >
        <SoftBadge
          variant="contained"
          color="error"
          size="xs"
          badgeContent={
              <SoftTypography color="dark" variant="button" >
                  Configuration Updated Succesfully 
              </SoftTypography>
          }
          circular
          container
          />
      </SoftBox>
    )}
  </Card>
);
}

export default AutoDeletePatients;
